import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../../../hooks/validation-group/validation-group-hook';
import ApiSecretCredentialsStore from '../../../../../stores/credentials/shipping/api-secret-credentials-store';
import CustomerNumberCredentialsStore from '../../../../../stores/credentials/shipping/customer-number-credentials-store';
import MondialRelayCredentialsStore from '../../../../../stores/credentials/shipping/mondial-relay-credentials-store';
import ReboundCredentialsStore from '../../../../../stores/credentials/shipping/rebound-credentials-store';
import SendcloudReturnsCredentialsStore
    from '../../../../../stores/credentials/shipping/sendcloud-returns-credentials-store';

interface IIntegrationProps {
    credentialsStore: ApiSecretCredentialsStore |
    CustomerNumberCredentialsStore |
    MondialRelayCredentialsStore |
    ReboundCredentialsStore |
    SendcloudReturnsCredentialsStore,
    validationGroup: IValidationGroup,
    label?: string,
    note?: string,
    disabled?: boolean,
}

const ApiSecretField: React.FC<IIntegrationProps> = observer(({ credentialsStore, validationGroup, label, note, disabled }) => {
    return (
        <FormFieldLine
            required
            label={label || 'Api Secret'}
            key='api_secret'
            note={note || 'Api secret for this account'}
        >
            <Input
                value={credentialsStore.apiSecret}
                onChange={credentialsStore.setApiSecret}
                validationGroup={validationGroup}
                type='password'
                autoComplete='new-password'
                required
                disabled={disabled}
            />
        </FormFieldLine>
    );
});

export default ApiSecretField;
